import { render, staticRenderFns } from "./StudentEnrollments.vue?vue&type=template&id=5b810d59&scoped=true"
import script from "./StudentEnrollments.vue?vue&type=script&lang=js"
export * from "./StudentEnrollments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b810d59",
  null
  
)

export default component.exports